module.exports = __webpack_public_path__ + "img/8.d553160d.png";